import axios, { AxiosResponse } from 'axios';

export interface IEditaceTextuData {
    id: string;
    cz: string;
    en: string;
}

export const editaceTextuGet = () => {
    return axios({
        method: 'GET',
        url: 'Portal/Texty'
    }).then((resp: AxiosResponse<IEditaceTextuData>) => resp.data);
};

export const editaceTextuPost = (data: IEditaceTextuData) => {
    return axios({
        method: 'POST',
        url: 'Portal/Texty',
        data: data
    }).then((resp: AxiosResponse<IEditaceTextuData>) => resp.data);
};
